/*
 * Why the last session ended, handed to the sign-in page.
 *
 * The sign-in page replaces the shell, toasts and all, so the reason for the
 * sign-out is handed over in sessionStorage and shown there once. Without it
 * the person comes back to a sign-in form with no idea why.
 */
const NOTICE_KEY = 'micarahr.signedOutNotice';

export function takeSignOutNotice(): string | null {
  try {
    const notice = window.sessionStorage.getItem(NOTICE_KEY);
    window.sessionStorage.removeItem(NOTICE_KEY);
    return notice;
  } catch {
    return null;
  }
}

export function leaveSignOutNotice(message: string) {
  try {
    window.sessionStorage.setItem(NOTICE_KEY, message);
  } catch {
    // Storage blocked: the sign-in form simply appears without the reason.
  }
}

/** When the server did not say how long the timeout is. */
export const IDLE_SIGN_OUT_NOTICE =
  'You were signed out after a period without activity. Sign in again to continue.';
